module.exports = __webpack_public_path__ + "static/media/colizonlogo.bd947b68.webp";